<template>
  <div>
    <input-icon
      :icon="{ name: 'search' }"
      id="search"
      name="search"
      type="text"
      @input="debounceSearch"
      label="Search:"
    ></input-icon>
  </div>
</template>

<script>
export default {
  name: 'InputSearch',
  data() {
    return {
      message: null,
      typing: null,
      debounce: null
    }
  },
  methods: {
    debounceSearch(event) {
      this.message = null
      this.typing = 'You are typing'
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        this.typing = null
        this.message = event
        if (event) {
          this.$emit('search', event)
        }
      }, 600)
    }
  }
}
</script>

<style>
</style>
